var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCreditCardMastercard = function SvgCreditCardMastercard(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2,0,0,2,0,0)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}")), /*#__PURE__*/React.createElement("title", null, "credit-card-mastercard"), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 0.75,
    y: 3.75,
    width: 22.5,
    height: 16.5,
    rx: 1.5,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 9,
    cy: 12,
    r: 3.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12,14.229a3.75,3.75,0,1,0,0-4.458"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCreditCardMastercard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "credit-card-mastercard.f847171a2fd35839c0d30f24b339d289.svg";